import React, { useState } from "react";
import { useSelector } from "react-redux";
import TestCard from "./TestCard";
import Tabs from "./Tabs";
import "./PaperListing.css";

export default function PyqListing() {
  const { selectedPyqYear, pyqYearPaperList, state } = useSelector(
    (state) => state.examSlice
  );

  const { tabs } = useSelector((state) => state.aitsTests);

  const [activeTab, setActiveTab] = useState("All Tests");

  const pyqTests =
    selectedPyqYear && pyqYearPaperList?.length > 0
      ? pyqYearPaperList
          .filter(
            (group) => String(group.target_year) === String(selectedPyqYear)
          )
          .flatMap((group) => group.data || [])
      : [];

  const filteredTests =
    activeTab === "All Tests"
      ? pyqTests
      : pyqTests.filter((test) => test.tab_name === activeTab);

  return (
    <>
      <div className="pyqListingWrapper">
        {tabs.length > 0 && (
          <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
        )}
      </div>

      <div className="pyqListingContent">
        {filteredTests.length > 0 ? (
          filteredTests.map((test) => (
            <TestCard key={test.paper_id} test={test} isPyq={true} />
          ))
        ) : (
          <p className="no_tests_text">No PYQ tests found.</p>
        )}
      </div>
    </>
  );
}
